<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('modules') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link to="/system/module" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$refs.file.click()"><i class="fa fa-upload"></i> {{ $t('import') }}</button>
        </div>
        <div class="x_body">
            <input type="file" ref="file" accept="application/json" style="display: none;" @change="onJsonSelect">
            <div class="card f_card">
                <div class="card-header">
                    <div class="card-item upper">{{ $t('modules') }}</div>
                </div>
                <div class="card-body p-0">
                    <table class="table no-bor">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                <th>{{ $t('code') }}</th>
                                <th>{{ $t('name') }}</th>
                                <th>Translate</th>
                                <th>{{ $t('url') }}</th>
                                <th class="text-center">{{ $t('icon') }}</th> 
                                <th class="text-center">{{ $t('sort') }}</th>
                                <th>{{ $t('lang_key') }}</th>
                                <th class="text-center">{{ $t('enabled') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{ret.Code}}</td>
                                <td><router-link :to="{ name: 'module_update', params: { id: ret.Id } }">{{ret.Name}}</router-link></td>
                                <td>{{$t(ret.LangKey)}}</td>
                                <td>{{ret.Url}}</td>
                                <td class="text-center"><i :class="ret.Icon" aria-hidden="true"></i></td>
                                <td class="text-center">{{ret.Sort}}</td>
                                <td>{{ret.LangKey}}</td>
                                <td class="text-center">
                                    <input type="checkbox" v-model="ret.Enabled" disabled>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            records: []
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('system/modules', {}).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Modules;
                }
            }).finally(function() { loading.hide(); });
        },
        onJsonSelect(){
            var loading = this.$loading.show();
            var formData = new FormData();
            formData.append('file', this.$refs.file.files[0]);
            this.$api().post('system/json-import-module', formData, this.formHead).then(res => {
                if (this.$isValid(res)) {
                    this.toList();
                }
            }).finally(function () {
                loading.hide();
            });
        }
    }
}
</script>